import { ImageIcon } from '@mybridge/icons';
import { IconButton } from '@mybridge/ui/icon-button';
import { Input } from '@mybridge/ui/input';
import { Box, HStack } from '@mybridge/ui/layout';
import { Tooltip } from '@mybridge/ui/tooltip';
import { useContext, useRef, useState } from 'react';
import { TeamsContext } from '../../context';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { ChatImageGalIcon, ChatFileUploaderIcon } from '@mybridge/icons/chat-icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDispatch } from 'react-redux';
import { sendMessageAction } from 'v4/store/actions/global.data.actions';

export const MediaPicker = ({ ...props }) => {
  const {
    gifs,
    images,
    videos,
    setVideos,
    setImages,
    setMediaUpdated,
    chatRoom,
    createTeamChatPosts,
    createTeamPostAsyncLoading,
    isMember,
    isOrganizer,
    teamDetails,
    handleFileTypes,
    addImage,
    addVideo,
  } = useContext(TeamsContext);
  const {
    matrixClient,
    loggedInUser,
    initiateMatrixCall,
    callStatus,
    callDetails,
    setCallDetails,
  } = useContext(MatrixContext);
  const { t } = useTranslator();
  const fileInputRef = useRef();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // const handleFileTypes = (file) => {
  //   if (file.type.includes('image')) {
  //     return 'm.image';
  //   } else if (file.type.includes('application')) {
  //     return 'm.file';
  //   } else if (file.type.includes('audio')) {
  //     return 'm.audio';
  //   } else if (file.type.includes('video')) {
  //     return 'm.video';
  //   } else {
  //     return;
  //   }
  // };

  const handleFilesChange = async (e) => {
    /*
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    const roomId = teamDetails?.room_id || chatRoom?.roomId || chatRoom?.id;

    setLoading(true);

    try {
      // Check team permissions first (same logic as chat-footer.jsx)
      if (
        !teamDetails?.permission_new_post &&
        isMember &&
        isMember?.status === 'member' &&
        !isOrganizer
      ) {
        // Handle team chat with restricted permissions - show pending message
        let payload = {};
        payload.body = selectedFile.name;

        // Check the file type and assign the correct msg_type
        const fileType = selectedFile.type;
        if (fileType.startsWith('image/')) {
          payload.msg_type = 'm.image';
        } else if (fileType.startsWith('video/')) {
          payload.msg_type = 'm.video';
        } else if (fileType.startsWith('audio/')) {
          payload.msg_type = 'm.audio';
        } else if (fileType === 'application') {
          payload.msg_type = 'm.doc';
        } else {
          payload.msg_type = 'm.file';
        }

        payload.file = selectedFile;

        // Use createTeamChatPosts for pending approval
        await createTeamChatPosts({
          id: teamDetails.id,
          message: selectedFile.name,
          message_category: payload.msg_type,
          file: payload.file
        });
        
        setLoading(false);
        return;
      }

      // For regular matrix chat or teams with permission_new_post = true
      const payload = {
        body: selectedFile.name,
        file: selectedFile,
        room_id: roomId,
      };

      // Determine message type
      const fileType = selectedFile.type;
      if (fileType.startsWith('image/')) {
        payload.msg_type = 'm.image';
      } else if (fileType.startsWith('video/')) {
        payload.msg_type = 'm.video';
      } else if (fileType.startsWith('audio/')) {
        payload.msg_type = 'm.audio';
      } else {
        payload.msg_type = 'm.file';
      }

      // Send using the same action as chat-footer
      await dispatch(sendMessageAction(payload));
      await props?.refreshRoomMessages();

    } catch (error) {
      console.error('Error uploading file:', error);
    } finally {
      setLoading(false);
    }
    */
    const selectedFiles = Array.from(e.target.files);
    if (!selectedFiles.length) return;

    for (let file of selectedFiles) {
      if (file.type.startsWith('image/')) {
        addImage?.(file);
      } else if (file.type.startsWith('video/')) {
        addVideo?.(file);
      }
    }
    e.target.value = '';
  };

  return (
    <HStack spacing={0}>
      <Tooltip
        hasArrow
        placement="top"
        variant="round"
        label={t('createPost.addImagesVideo') ||  "Add Images/Video"}
      >
        <IconButton
          variant="ghost"
          isDisabled={
            gifs?.length > 0 || videos?.length > 0 || images?.length >= 5
          }
          onClick={() => fileInputRef?.current?.click?.()}
          isLoading={createTeamPostAsyncLoading}
        >
          {/* <ImageIcon color={props?.color ? props?.color : '#3D5A80'} /> */}
         {/* <ChatFileUploaderIcon> */}
           <ChatImageGalIcon color={props?.color ? props?.color : '#3D5A80'} />
        </IconButton>
      </Tooltip>
      <Box w="0" h="0" overflow="hidden">
        <Input
          multiple
          onChange={handleFilesChange}
          ref={fileInputRef}
          w={0}
          h={0}
          visibility="hidden"
          type="file"
        />
      </Box>
    </HStack>
  );
};
